import { useLocalDataSource } from './useLocalDataSource';
import { useRemoteDataSource } from './useRemoteDataSource';
import { useAuth } from '../hooks/useAuth';

/**
 * Data source abstraction - uses localStorage for unauthenticated users,
 * remote API for authenticated users
 * @param {string} calendarId - Calendar identifier
 * @returns {Object} Calendar data and CRUD operations
 */
export function useDataSource(calendarId) {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  
  // Use local storage for unauthenticated users
  const localData = useLocalDataSource(calendarId);
  
  // Use remote API for authenticated users
  const remoteData = useRemoteDataSource(isAuthenticated ? calendarId : null);
  
  // While auth is loading, return local data with loading state
  if (authLoading) {
    return {
      ...localData,
      isLoading: true,
    };
  }
  
  // Return appropriate data source
  return isAuthenticated ? remoteData : localData;
}
